import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Modal, Button, Form, Image } from 'react-bootstrap';
import LogoBanner from "../components/logobanner.png";
import '../styles/mystyles.css';
import { subtleLinkStyle } from '../styles/linkStyle';
import { FaQuestion, FaEnvelope, FaCheck } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { usePresetStore } from "../components/datastore.js";
import { useAuthStore } from '../store/auth';
import useAxios from '../utils/useAxios';
import { useUkIhtVisible } from '../utils/useUserCountry';
import ScreenShot from "../components/Screenshot1.png";

function Intro() {
    const api_key = 'seh3599f@fUERkdf22&^2{u'
	const navigate = useNavigate();
	const api = useAxios();
	const presetObject = usePresetStore((state) => state.presetObject);
	// UK inheritance tax mentions: hidden from visitors outside the UK unless the admin setting shows them
	const ukIhtVisible = useUkIhtVisible();
    const setPresetObject = usePresetStore((state) => state.setPresetObject);
    const resetPresetObject = usePresetStore((state) => state.resetPresetObject);

    const triggerAutoRunSimulation = usePresetStore((state) => state.triggerAutoRunSimulation);
    const resetAutoRunSimulation = usePresetStore((state) => state.resetAutoRunSimulation);
    const isLoggedIn = useAuthStore().isLoggedIn();
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 576);

    // Temporary gate on the AI wizard while it's in testing — see
    // AIFeatureAccess / HasAIFeatureAccess on the backend. Defaults to
    // false (button hidden) until proven otherwise for this user.
    const [aiFeaturesEnabled, setAiFeaturesEnabled] = useState(false);
    useEffect(() => {
      if (!isLoggedIn) { setAiFeaturesEnabled(false); return; }
      let cancelled = false;
      api.get('/userinformation/')
        .then((response) => { if (!cancelled) setAiFeaturesEnabled(!!response.data.ai_features_enabled); })
        .catch(() => { if (!cancelled) setAiFeaturesEnabled(false); });
      return () => { cancelled = true; };
    }, [isLoggedIn]);
	
	const [equityAllocation, setEquityAllocation] = useState(70)
	const [showModal, setShowModal] = useState(false);
	const [showRedirectModal, setShowRedirectModal] = useState(false);
	// this is set at 1 to hop the first question (which is now automated)
	const [questionIndex, setQuestionIndex] = useState(1);

    const [userLocation, setUserLocation] = useState('');

    useEffect(() => {
      const fetchUserLocation = async () => {
        let apiroute = ""
        try {
        apiroute = "getlocation";
        const response = await fetch(`/api/${apiroute}/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': api_key, // Set the custom header here
            },
        });
        const data = await response.json();
        // console.log(data.country)
        if (data.country == 'GB') {
          usePresetStore.getState().setRegionDefaults({currency_set: 'GBP', geographic_set: 'GLOBAL', default_return_source: 'fca'});  // (kept by later resets)
        setPresetObject({['currency_set']: 'GBP'});
          setPresetObject({['geographic_set']: 'GLOBAL', ['default_return_source']: 'fca'});
        //   setPresetObject({['data_option']: 'forward'});
        }
        } catch (error) {
        //   setModalmessage('Could not auto-detect location to set currency denomination. Check and set in Simulation data options.'); openModal();
		} 
      }
      fetchUserLocation();
    }, []);

	const [responses, setResponses] = useState({
		question1: '',
		question2: null,
		question3: '',
		question4: null,
		question5: '',
		question6: null,
		question7: null,
		question8: '',
		question9: null,
		question10: null,
		question11: '',
		question12: null,
		question13: null,
		question14: '',
		question15: null,
		question16: null,
		question17: '',
		question18: null,
	});

	const resetResponseFields = () => {
		setResponses({
		  question1: '',  // Corrected to use string keys
		  question2: null,
		  question3: '',
		  question4: null,
		  question5: '',
		  question6: null,
		  question7: null,
		  question8: '',
		  question9: null,
		  question10: null,
		  question11: '',
		  question12: null,
		  question13: null,
		  question14: '',
		  question15: null,
		  question16: null,
		  question17: '',
		  question18: null,
		});
	  };
	
	const [errors, setErrors] = useState({
		question1: '',
		question2: '',
		question3: '',
		question4: '',
		question5: '',
		question6: '',
		question7: '',
		question8: '',
		question9: '',
		question10: '',
		question11: '',
		question12: '',
		question13: '',
		question14: '',
		question15: '',
		question16: '',
		question17: '',
		question18: '',
	});

	// Array of questions with their type (text or yes/no)
	const questions = [
		{ question: "Are you a UK or US investor?", type: "radio", options: ['UK', 'US'], validation: (input) => input === 'UK' || input === 'US' },
		{ question: "What is your age?", type: "number", validation: (input) => !isNaN(input) && input >= 0 && input <= 100 },
		{ question: "Are you retired yet?", type: "radio", options: ['Yes', 'No'], validation: (input) => input === 'Yes' || input === 'No' },
		{
			question: "At what age do you plan to retire?", 
			type: "number", 
			validation: (input, responses) => {
				if (typeof responses['question2'] === 'undefined' || responses['question2'] === '') {return false;}
				const currentAge = parseInt(responses['question2'], 10); 
				return !isNaN(input) && input > currentAge && input <= 100;
			}, 
			condition: (responses) => responses['question3'] === 'No'
		},
		{ question: "Do you expect to receive a state pension / social security?", type: "radio", options: ['Yes', 'No'], validation: (input) => input === 'Yes' || input === 'No' },
		{ question: "How much do you expect to receive (per year, in current value)?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question5'] === 'Yes'},
		{ question: "At what age will you receive it?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question5'] === 'Yes' },
		{ question: "Do you expect to receive a (defined benefit) occupational pension?", type: "radio", options: ['Yes', 'No'], validation: (input) => input === 'Yes' || input === 'No' },
		{ question: "How much do you expect to receive (per year, in current value)?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question8'] === 'Yes'},
		{ question: "At what age will you receive it?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question8'] === 'Yes' },
		{ question: "Do you have retirement savings (such as a  defined contribution pension fund)? (NB. do not include any property that you plan to sell in the future to provide retirement income - this is captured in a following question)", type: "radio", options: ['Yes', 'No'], validation: (input) => input === 'Yes' || input === 'No' },
		{ question: "How much do you currently have in your retirement savings?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question11'] === 'Yes' },
		{ question: "How much are you saving into your retirement savings each year?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question3'] === 'No' },
		{ question: "Do you expect any other one-off inflows into your retirement savings (e.g. future property sale)?", type: "radio", options: ['Yes', 'No'], validation: (input) => input === 'Yes' || input === 'No' },
		{ question: "How much do you expect to receive (in current value)?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question14'] === 'Yes' },
		{ question: "At what age will you receive it?", type: "number", validation: (input) => !isNaN(input) && input >= 0, condition: (responses) => responses['question14'] === 'Yes' },
		{ question: "How are your retirement savings currently invested?", type: "radio", options: [
		  'Mostly equities - for higher returns with higher volatility',
		  'Balanced equities and bonds - for moderated volatility'
		], validation: (input) => input === 'Mostly equities - for higher returns with higher volatility' || input === 'Balanced equities and bonds - for moderated volatility', condition: (responses) => responses['question11'] === 'Yes' || responses['question13'] > 0 || responses['question14'] > 0 },
		{ question: "How much do you plan to spend each year in retirement (in current value)?", type: "number", validation: (input) => !isNaN(input) && input >= 0 }
	  ];

	useEffect(() => {
		responses['question17'] === 'Mostly equities - for higher returns with higher volatility' ? setEquityAllocation(70) : setEquityAllocation(40)
	}, [responses['question17']])

	// Functions to show and hide the modal
	const handleShow = () => setShowModal(true);
	const handleClose = () => 
		{
			setQuestionIndex(1);
			resetResponseFields();
			setShowModal(false);
		}
	const handleRedirectShow = () => setShowRedirectModal(true);
	const handleRedirectClose = () => 
		{
			setShowRedirectModal(false);
			resetPresetObject();

			const retireyear = responses['question4'] ? parseInt(responses['question4'], 10) : parseInt(responses['question2'], 10);		
			setPresetObject({
				data_direction: "forward",
				start_simulation_age: parseInt(responses['question2'], 10),
				end_simulation_age: 100,
				// (the mix chosen here, not one derived from the asset portfolio)
				asset_mix_source: '1',
				asset_mix_equity: equityAllocation,
				asset_mix_bond: (100 - equityAllocation) / 2,
				asset_mix_index_bond: (100 - equityAllocation) / 2,
				equity_tax: 0,
				bond_tax: 0,
				draw_tax: 0,
				base_tax_rate: 0,
				annuity_tax_rate: 0,
				state_pension_tax_rate: 0,
				occupational_pension_tax_rate: 0,
				fees: 0,
			});
			if (responses['question6']) {
				setPresetObject({
					state_pension: [{name: 'State pension / social security', year: responses['question7'], amount: responses['question6'], index: '1', increase: '0', last_update_date: '2024-01-01'}]
				});}
			if (responses['question9']) {
				setPresetObject({
					occupational_pension: [{name: 'Occupational pension', year: responses['question10'], amount: responses['question9'], index: '1', increase: '0', last_update_date: '2024-01-01'}]
			});}
			if (responses['question12']) {
				setPresetObject({
				  	asset_portfolio: [{name: 'Retirement savings', type: '2', amount: responses['question12'], equity: String(equityAllocation), bonds: String(100 - equityAllocation), index: '0', last_update_date: '2024-01-01'}]
				});}
			if (responses['question13']) {
				setPresetObject({
					contribution_inflows: [{name: 'Contribution to savings', year: responses['question2'], yearend: retireyear, amount: responses['question13'], index: '1', increase: '0', type: '2', last_update_date: '2024-01-01'}]
				});}
			if (responses['question15']) {
				setPresetObject({
					extraordinary_inflows: [{name: 'One-off inflow', year: responses['question16'], amount: responses['question15'], index: '1', increase: '0', type: '0', last_update_date: '2024-01-01'}]
				});}

			if (responses['question18']) {
				setPresetObject({
					income_requirements: [{name: 'Expenditure in retirement', single_year: '0', year: retireyear, yearend: '100', date_start: '2024-01-01', date_end: '2024-01-01', amount: responses['question18'], index: '1', increase: '0', increase2: '0', last_update_date: '2024-01-01', percent_covered: 100, january: '0', february: '0', march: '0', april: '0', may: '0', june: '0', july: '0', august: '0', september: '0', october: '0', november: '0', december: '0'}]
				});}
			triggerAutoRunSimulation();
			navigate('/calc');
		}

	const handleNext = () => {
		const currentQuestion = questions[questionIndex];
		const response = responses[`question${questionIndex + 1}`];
	
		// Pass responses explicitly to the validation function
		if (!currentQuestion.validation(response, responses)) {
			// Handle validation error
			setErrors({
				...errors,
				[`question${questionIndex + 1}`]: "Invalid response. Please check your input."
			});
			return;
		}
	
		// If valid, clear error and move to next question
		setErrors({
			...errors,
			[`question${questionIndex + 1}`]: ''
		});

		// Find the next question that meets the condition or doesn't have a condition
		let nextIndex = questionIndex + 1;
		while (nextIndex < questions.length && questions[nextIndex].condition && !questions[nextIndex].condition(responses)) {
			nextIndex++;
		}
	
		if (nextIndex < questions.length) {
			setQuestionIndex(nextIndex);
		} else {
			// All valid questions answered, handle submission here
			// console.log('Responses:', responses);
			setShowModal(false);  // Close the modal when done
			setShowRedirectModal(true);
		}
	};

	// Update the response for the current question
	const handleInputChange = (e) => {
		const currentQuestionKey = `question${questionIndex + 1}`;
		setResponses({
		...responses,
		[currentQuestionKey]: e.target.value,
		});
	};

	const navToSimCalcStartPlan = () => {
		triggerAutoRunSimulation();
		navigate('/calc');
	};

	// Navigate to calc — wizard opens there after market data has loaded
	const handleShowWizard = () => {
		navigate('/calc', { state: { openWizard: true } });
	};

	// const navToSimulationCalculator = () => {
	// 	navigate('/calc');
	// };

	const navToSimulationCalculator = () => {
		navigate('/calc');
	};

	const navToRetirementOptimiser = () => {
		navigate('/decumulation');
	};

	const navToBondLadder = () => {
		navigate('/ladder');
	};

	const navToQuickTest = () => {
		navigate('/quicktest');
	};

	const navToPortfolioDesign = () => {
		navigate('/planrisk');
	};

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 576);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const webpageData = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "RetireSecure",
        "url": "https://www.retiresecure.com",
        "logo": "https://www.retiresecure.com/logo.png",
        "description": "Retirement cash flow planning simulator for UK investors. Model sustainable spending, drawdown strategies, secure income and inheritance tax mitigation.",
        "applicationCategory": "FinanceApplication",
        "operatingSystem": "Any",
        "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "GBP"
        }
    };

    return (
        <>
            <Helmet>
                <title>RetireSecure | Retirement Planning Simulator</title>
                <link rel="icon" href="https://www.retiresecure.co.uk/logo.png" />
                <link rel="canonical" href="https://www.retiresecure.co.uk/" />
                <meta name="description" content="Retirement cash flow planning simulator for UK investors. Model sustainable spending, drawdown strategies, secure income and inheritance tax mitigation." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.retiresecure.co.uk/" />
                <meta property="og:title" content="RetireSecure | Retirement Planning Simulator" />
                <meta property="og:description" content="Retirement cash flow planning simulator for UK investors. Model sustainable spending, drawdown strategies, secure income and inheritance tax mitigation." />
                <meta property="og:image" content="https://www.retiresecure.co.uk/logo.png" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="RetireSecure | Retirement Planning Simulator" />
                <meta name="twitter:description" content="Retirement cash flow planning simulator for UK investors. Model sustainable spending, drawdown strategies, secure income and inheritance tax mitigation." />
                <meta name="twitter:image" content="https://www.retiresecure.co.uk/logo.png" />
                <script type="application/ld+json">{JSON.stringify(webpageData)}</script>
            </Helmet>


            {/* ── Hero ──────────────────────────────────────────────────────── */}
            <div className="intro-hero">
                <div className="intro-hero-glow" />
                <div className="intro-hero-inner">
                    <img src={LogoBanner} alt="RetireSecure" className="intro-hero-logo" />
                    <div className="intro-hero-pills">
                        <div className="intro-hero-pill">
                            <span className="intro-hero-pill-dot">•</span>
                            <span>Build a cash flow plan</span>
                        </div>
                        <div className="intro-hero-pill">
                            <span className="intro-hero-pill-dot">•</span>
                            <span>Backtest through history</span>
                        </div>
                        <div className="intro-hero-pill">
                            <span className="intro-hero-pill-dot">•</span>
                            <span>Optimise drawdown vs. secure income</span>
                        </div>
                        {ukIhtVisible &&
                        <div className="intro-hero-pill">
                            <span className="intro-hero-pill-dot">•</span>
                            <span>Mitigate inheritance tax</span>
                        </div>}
                    </div>
                    <div className="intro-hero-body">
                        <p>RetireSecure is a retirement cash flow planning simulator. You input target retirement income, your current portfolio, planned savings, retirement timing, etc — and the simulation tests the plan through different backtest scenarios and tells you how it holds up.</p>
                        <p>It helps design a decumulation strategy that follows leading <Link className="content-link" to="/research">academic research</Link> - this includes finding the mix of portfolio drawdown income and purchased secure income (e.g. an annuity or index bond ladder) that best balances potential portfolio growth against sustainable income through retirement.</p>
                        <p>It is designed primarily for <Link className="content-link" to="/whoisitfor">UK investors</Link> and offers a choice of GBP and USD denominated simulation datasets. It incorporates the UK tax treatment of various account types and accommodates both individual and joint (couple) plans.{ukIhtVisible && <> It can simulate UK <Link className="content-link" to="/inheritancetax">inheritance tax</Link> and help test mitigation strategies.</>} It is free to use.</p>
                    </div>
                </div>
            </div>

            {/* ── Tool cards ────────────────────────────────────────────────── */}
            <div className="intro-section">
                <div className="intro-section-inner">
                    <h2 className="intro-section-title">Test strategies or build a full plan:</h2>
                    <div className="intro-cards">

                        <div className="intro-card">
                            <h3 className="intro-card-title">Quick Test</h3>
                            <p className="intro-card-body">
                                See sustainable income and legacy portfolio potential from different decumulation strategies given current interest rates.
                            </p>
                            <button className="intro-card-btn" onClick={navToQuickTest}>Open →</button>
                        </div>

                        <div className="intro-card">
                            <h3 className="intro-card-title">Strategy Comparison</h3>
                            <p className="intro-card-body">
                                Takes your plan inputs and compares simulation outcomes across different drawdown and secure income decumulation strategies. Use to understand strategy choices before building a full plan in Plan Simulator.
                            </p>
                            <button className="intro-card-btn" onClick={navToRetirementOptimiser}>Open →</button>
                        </div>

                        <div className="intro-card">
                            <h3 className="intro-card-title">Full Plan Simulator</h3>
                            <p className="intro-card-body">
                                Full range of plan input and simulation model choices. Explore secure income strategies, dynamic asset allocation, all withdrawal methods and lifetime gifting options. Plans can be saved and retrieved when logged in.
                            </p>
                            {isLoggedIn && aiFeaturesEnabled && (
                                <button className="intro-cta-primary" onClick={handleShowWizard}>
                                    ✨ Build a starter plan with AI
                                </button>
                            )}
                            <button className="intro-card-btn" onClick={navToSimulationCalculator}>Open →</button>
                        </div>

                        <div className="intro-card">
                            <h3 className="intro-card-title">Bond Ladder</h3>
                            <p className="intro-card-body">
                                Build a ladder of government index-linked bonds to provide a secure income floor. Use in conjunction with Plan Simulator once you have decided which retirement income needs you want to cover with a ladder.
                            </p>
                            <button className="intro-card-btn" onClick={navToBondLadder}>Open →</button>
                        </div>

                    </div>
                </div>
            </div>

            {/* ── Footer strip ──────────────────────────────────────────────── */}
            <div className="intro-footer-strip">
                <div className="intro-footer-inner">
                    <p className="intro-disclaimer">
                        RetireSecure does not constitute financial advice. It is intended for educational and informational purposes only, for experienced investors who understand that future returns may differ from historic returns. Seek advice from a qualified financial adviser if unsure. <Link className="content-link" to="/terms">Terms of service.</Link>
                    </p>
                    <p className="intro-contact">
                        <FaEnvelope style={{ marginRight: '6px', verticalAlign: 'middle', opacity: 0.6 }} />
                        contact@retiresecure.co.uk
                    </p>
                </div>
            </div>

            {/* ── Redirect modal ────────────────────────────────────────────── */}
            <Modal show={showRedirectModal} onHide={handleRedirectClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Start a Plan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>You will now be taken to the simulator where your responses have been used to create a starter plan. Press <strong>Run Simulation</strong> to test it.</p>
                    <p>You can edit, extend and re-test the plan at any time.</p>
                    <ul>
                        <li>Currency set to {presetObject.currency_set === 'GBP' ? 'GBP/UK' : 'USD/US'}</li>
                        <li>End of plan set to age 100</li>
                        <li>Tax deductions set at 0% — adjust in the simulator to match your circumstances</li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-run-sim" onClick={handleRedirectClose}>Continue</button>
                </Modal.Footer>
            </Modal>

        </>
    );
}

export default Intro;



